import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from 'haba-core';

@NgModule({
  declarations: [],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        CartCustomModule: {
          module: () =>
            import('src/app/misc/global-message/global-message-custom.module').then(
              (m) => m.GlobalMessageCustomComponentModule
            ),
        },
      },
    }),
  ],
})
export class GlobalMessageCustomComponentFeatureModule {}
